import getCanvas from '../helpers/getCanvas';

const labelToPlaceholder = (html) => {
  const canvas = getCanvas(html);
  const form = canvas.querySelector('form');

  if (!form) {
    return html;
  }

  const inputs = form.querySelectorAll('input');

  Array.from(inputs).forEach((element) => {
    const elementId = element.getAttribute('id');
    const labels = form.querySelectorAll(`label[for="${elementId}"]`);

    if (elementId && labels.length === 1) {
      const label = labels[0];

      element.setAttribute('placeholder', label.textContent);
      label.parentNode.removeChild(label);
    }
  });

  return canvas.innerHTML;
};

export default labelToPlaceholder;



/** WEBPACK FOOTER **
 ** ./src/helpers/form/filters/factories/labelToPlaceholder.js
 **/